import './map-tile.styles.scss';

const MapTile = ({tile}) => {
    return <div className={`tile ${tile}`} />
}

export default MapTile;